import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useBjelinTranslations } from "../../../hooks/TranslationHooks";
import FieldError from "./FieldError";
import FieldRequired from "./FieldRequired";

const BusinessFields = ({
  companyName,
  companyNameCallback,
  vatNumber,
  vatNumberCallback,
  errors,
  readOnly = false,
  required
}) => {
  const t = useBjelinTranslations();
  if (readOnly)
    return (
      <Row>
        <Col sm={6}>
          <FormGroup>
            <Label>{t("company.name")}</Label>
            {companyName}
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <Label>{t("vat.number")}</Label>
            {vatNumber}
          </FormGroup>
        </Col>
      </Row>
    );
  return (
    <Row>
      <Col sm={6}>
        <FormGroup>
          <Label>
            {t("company.name")}
            {required && <FieldRequired />}
            <Input
              type={"text"}
              className={"input-companyName"}
              value={companyName}
              onChange={e => companyNameCallback(e.target.value)}
              placeholder={t("company.name")}
              invalid={!!errors.companyName}
            />
          </Label>
          <FieldError errors={errors} field={"companyName"} />
        </FormGroup>
      </Col>
      <Col sm={6}>
        <FormGroup>
          <Label>
            {t("vat.number")}
            {required && <FieldRequired />}
            <Input
              type={"text"}
              className={"input-vatNumber"}
              value={vatNumber}
              onChange={e => vatNumberCallback(e.target.value)}
              placeholder={t("vat.number")}
              invalid={!!errors.vatNumber}
            />
          </Label>
          <FieldError errors={errors} field={"vatNumber"} />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default BusinessFields;
